export const slugify = (s: string) =>
  s.toLowerCase().replace(/[^ء-يa-z0-9]+/g, "-").replace(/(^-|-$)/g, "");